document.addEventListener('DOMContentLoaded', function (e) {
  const contactOpener = document.querySelector('.contact-opener');

  contactOpener?.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.classList.toggle('opened-contact');
  });
});
